import React from 'react';
import PropTypes from 'prop-types';
import '../styles/message.css';

const Message = ({ title, message }) => {
    const formattedMessage = message.split('\n').filter(line => line.trim() !== '').map((line, index) => {
        return (
            <p key={index} dangerouslySetInnerHTML={{ __html: line.trim() }} />
        );
    });

    return (
        <div className="message-div">
            <h1>{title}</h1>
            <div>{formattedMessage}</div>
        </div>
    );
}

Message.propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired
}

export default Message;
